import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { Navigation } from 'swiper/modules';
import { Pagination } from 'swiper/modules';
import { EffectFade } from 'swiper/modules';
import Lenis from 'lenis';
import { gsapHorizontalLoop } from './gsapHorizontalLoop';
import { statisticModule } from './statistic';

// CSS
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

// Register Plugins
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);
gsap.registerPlugin(ScrollTrigger, SplitText);
Alpine.plugin(collapse);

statisticModule();

// Global

window.Alpine = Alpine;
window.gsap = gsap;
window.SplitText = SplitText;
window.ScrollTrigger = ScrollTrigger;
window.Swiper = Swiper;
window.Lenis = Lenis;
window.gsapHorizontalLoop = gsapHorizontalLoop;

// Inits
Alpine.start();

const lenis = new Lenis({
    autoRaf: true,
    duration: 1,
    anchors: true,
    prevent: (node) => node.classList?.contains('js-modal') || node.classList?.contains('js-drawer')
});

lenis.on('scroll', () => {
    ScrollTrigger.update();
});